import React from 'react'
import { useAccountPageUIContext } from '../AccountPageProvider'

// ─── Generic overlay panel ────────────────────────────────────────────────────
// Transparent backdrop + brand-coloured panel card. Used by CancelDialog,
// AccountEmailFlowOverlay, and any future account-page sheet/modal.

export const AccountPageOverlayPanel = ({
  onClose,
  children,
}: {
  onClose: () => void
  children: React.ReactNode
}) => {
  const { uiConfig: config } = useAccountPageUIContext()
  return (
    <div
      className='ui-absolute ui-inset-0 ui-z-[100] ui-flex ui-items-start @[768px]:ui-items-center ui-justify-center ui-p-[16px] ui-pt-[68px] @[768px]:ui-pt-[16px]'
      onClick={e => { e.stopPropagation(); onClose() }}
    >
      <div
        className='ui-w-full ui-flex ui-flex-col ui-overflow-clip ui-rounded-[12px] ui-overflow-y-auto'
        style={{
          maxWidth: '440px',
          maxHeight: '100%',
          backgroundColor: config.layout.background_color,
          boxShadow: '0px 0px 0px 1.2px rgba(0,0,0,0.04), 0px 54px 80px -5px rgba(0,0,0,0.15), 0px 12px 18px 0px rgba(0,0,0,0.05), 0px 4px 6px 0px rgba(0,0,0,0.03)',
        }}
        onClick={e => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  )
}
